import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../utils/service";

export async function googleAuth() {
  try {
    const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GOOGLEAUTH ,
        callParams
      );
      return response;
  
  } catch (error) {
    throw error;
  }
}

export async function googleAccount() {
  try {
    const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GOOGLEACCOUNT ,
        callParams
      );
      return response;
  
  } catch (error) {
    throw error;
  }
}

export async function CreateBasic(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.MEETINGBASIC, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProjectDetails(payload:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETPROJECTLIST}?status=${payload.status}&userId=${payload.userId || ""}&page=0&limit=100`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getMeeting(payload: {
  userId?: string;
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  scope?: "mine" | "all";
  organizationId?: string;
} = {}) {
  try {
    const params = new URLSearchParams();
    if (payload.userId) params.set("userId", String(payload.userId));
    params.set("pageIndex", String(payload.pageIndex ?? 0));
    params.set("pageSize", String(payload.pageSize ?? 25));
    if (payload.search) params.set("search", payload.search);
    if (payload.scope) params.set("scope", payload.scope);
    if (payload.organizationId) {
      params.set("organizationId", payload.organizationId);
    }
    const callParams = await getCallParams("GET");
    return makeCall(`${urls.MEETING}?${params.toString()}`, callParams);
  } catch (error) {
    throw error;
  }
}
export async function getMeetingById(payload:any) {
    try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.MEETING}/${payload}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getHostMeeting(hostId: string) {
  try {
    const callParams = await getCallParams("GET");
    return makeCall(`${urls.HOSTMEETING}${hostId}`, callParams);
  } catch (error) {
    throw error;
  }
}

export async function CreateAvailability(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.MEETINGAVAILABILITY}${body.meetingId}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CreateScheduling(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.MEETINGSCHEDULING}${body.meetingId}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GenerateSlots(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.GENERATESLOTS}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateBasic(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(`${urls.MEETINGBASIC}/${body.meetingId}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteMeeting(meetingId: string) {
  const callParams = await getCallParams("DELETE");
  return makeCall(`${urls.MEETING}/${meetingId}`, callParams);
}